import Image from "next/image";
import React from "react";

const Amenity = ({ icon, text }) => {
  return (
    <div className="flex items-center sm:gap-1.5 gap-1">
      <div className="flex items-center justify-center sm:w-[34px] w-7 sm:h-[34px] h-7 rounded-md bg-themebgColor bg-opacity-20">
        <Image
          src={icon}
          width={18}
          height={18}
          alt="amenity"
          className="object-contain"
        />
      </div>
      <span className="text-themeBlack text-sm font-medium whitespace-nowrap">
        {text}
      </span>
    </div>
  );
};

export default Amenity;
